<!-- TEMPLATE -->
<template>
  <div class="roles-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
              <span class='avenir-heavy'>Rollen</span>
          </span>
          <dean-section-title-item
              :icon="plusIcon"
              :content="true"
              @click.native="sectionRoute('auth.admin.role.add')">
            toevoegen
          </dean-section-title-item>
        </dean-section-title>
        <dean-table
            :data='data'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick">
        </dean-table>
        <dean-pagination
            :current-page='tableMetaData.pageNumber'
            :total-items='tableMetaData.totalResults'
            :items-per-page='tableMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='tableMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import {mixins} from 'vue-class-component';

  import {
    plusIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })

  export default class List extends mixins(deanTableMixin, sideMenuAdminMixin) {
    // DATA
    public plusIcon: object = plusIcon;
    public data: Array<{
      name: string,
      type: string,
      level: number,
    }> = [];

    public columns: any = {
      name: {
        content: 'naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      type: {
        content: 'type',
        align: 'center',
        sort: true,
        dql: 'type',
      },
      level: {
        content: 'level',
        align: 'center',
        sort: true,
        dql: 'level',
      },
    };

    // COMPUTED
    get tableMetaData() {
      return this.pageMeta;
    }

    public tableName(): string {
      return 'auth-roles';
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/admin.roles.list', {
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        sort: data.sort,
      }).then(
        (response) => {
          this.data = response.data.data;
          this.updateMeta(response.data.meta);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public cellClick(target: any) {
      this.$router.push({
        name: 'auth.admin.role.edit',
        params: {id: target.row.id},
      });
    }

    public sectionRoute(name: string) {
      this.$router.push({name});
    }

    public created() {
      this.setDefaultSort('level');
      this.loadList(this.pageMeta);
      this.buildSideMenuAdmin();
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

</style>
